import useHandler from './useHandler'
import { useDispatch } from 'react-redux'

export const useAction = action => {
  const dispatch = useDispatch()

  return useHandler((...args) => dispatch(action(...args)))
}
